(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-content-page"]) return;
  try {
    
  class SlContentPage extends HTMLElement {
    connectedCallback() {
      this.highlightPlaceholders();
      if (this.dataset.layout === 'legal') this.buildToc();
      if (this.dataset.layout === 'faq') this.buildFaq();
    }

    highlightPlaceholders() {
      var body = this.querySelector('.sl-content-page__body');
      if (!body) return;

      var pattern = /(\{\{\s*[A-Z0-9_]+\s*\}\}|\[[^\]\n]*PENDIENTE[^\]\n]*\])/g;
      var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
      var nodes = [];
      var node;
      while ((node = walker.nextNode())) {
        if (pattern.test(node.nodeValue)) nodes.push(node);
        pattern.lastIndex = 0;
      }

      nodes.forEach(function (textNode) {
        var value = textNode.nodeValue;
        var frag = document.createDocumentFragment();
        var lastIndex = 0;
        var match;
        pattern.lastIndex = 0;
        while ((match = pattern.exec(value))) {
          frag.appendChild(document.createTextNode(value.slice(lastIndex, match.index)));
          var mark = document.createElement('mark');
          mark.className = 'sl-content-page__placeholder';
          mark.textContent = match[0];
          frag.appendChild(mark);
          lastIndex = match.index + match[0].length;
        }
        frag.appendChild(document.createTextNode(value.slice(lastIndex)));
        textNode.parentNode.replaceChild(frag, textNode);
      });
    }

    buildToc() {
      var body = this.querySelector('.sl-content-page__body');
      if (!body) return;
      var headings = body.querySelectorAll('h2[id]');
      if (headings.length < 2) return;

      var nav = document.createElement('nav');
      nav.className = 'sl-content-page__toc';
      nav.setAttribute('aria-label', 'Índice de contenidos');

      var title = document.createElement('p');
      title.className = 'sl-content-page__toc-title';
      title.textContent = 'Índice';
      nav.appendChild(title);

      var list = document.createElement('ol');
      headings.forEach(function (heading) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent;
        li.appendChild(a);
        list.appendChild(li);
      });
      nav.appendChild(list);

      body.parentNode.insertBefore(nav, body);
    }

    buildFaq() {
      var body = this.querySelector('.sl-content-page__body');
      if (!body) return;

      var paragraphs = Array.prototype.filter.call(body.children, function (el) {
        return el.tagName === 'P' && el.firstElementChild && el.firstElementChild.tagName === 'STRONG';
      });
      if (!paragraphs.length) return;

      var list = document.createElement('div');
      list.className = 'sl-faq-list';

      paragraphs.forEach(function (p) {
        var strongEl = p.querySelector('strong');
        var question = strongEl.textContent.trim();
        var answerHTML = p.innerHTML.replace(strongEl.outerHTML, '').trim();

        var details = document.createElement('details');
        details.className = 'sl-faq-item';

        var summary = document.createElement('summary');
        summary.textContent = question;

        var answer = document.createElement('div');
        answer.className = 'sl-faq-item__answer';
        answer.innerHTML = answerHTML;

        details.appendChild(summary);
        details.appendChild(answer);
        list.appendChild(details);
        p.remove();
      });

      body.insertBefore(list, body.firstChild);
    }
  }

  if (!customElements.get('sl-content-page')) {
    customElements.define('sl-content-page', SlContentPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-sticky-mobile-buy-bar"]) return;
  try {
    
  function slInitStickyBuyBar() {
    var bar = document.querySelector('.sl-sticky-buy');
    if (!bar) return;

    var realForm = document.querySelector('product-form');
    var realButton = realForm ? realForm.querySelector('.product-form__submit') : null;
    if (!realButton) return;

    var priceSource = document.querySelector('.product__info-wrapper .price');
    var priceTarget = bar.querySelector('.sl-sticky-buy__price');
    var stickyButton = bar.querySelector('.sl-sticky-buy__btn');

    function syncPrice() {
      if (priceSource && priceTarget) {
        priceTarget.innerHTML = priceSource.innerHTML;
      }
    }

    function syncButtonState() {
      stickyButton.disabled = realButton.disabled;
      var realLabel = realButton.querySelector('span');
      var stickyLabel = stickyButton.querySelector('span');
      if (realLabel && stickyLabel) {
        stickyLabel.textContent = realLabel.textContent;
      }
    }

    syncPrice();
    syncButtonState();

    if (priceSource && 'MutationObserver' in window) {
      new MutationObserver(syncPrice).observe(priceSource, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(syncButtonState).observe(realButton, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    stickyButton.addEventListener('click', function () {
      if (!stickyButton.disabled) {
        realButton.click();
      }
    });

    // FASE 1A: en móvil la barra va abajo; se oculta cuando el footer entra en
    // pantalla para no tapar iconos de pago ni copyright.
    var footerEl = document.querySelector('footer');
    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

    var ticking = false;
    function updateVisibility() {
      ticking = false;
      var formBottom = realForm.getBoundingClientRect().bottom;
      var show = formBottom < 0;
      if (show && footerEl && mobileQuery && mobileQuery.matches) {
        show = footerEl.getBoundingClientRect().top >= window.innerHeight;
      }
      bar.classList.toggle('sl-sticky-buy--visible', show);
    }
    function onScrollOrResize() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateVisibility);
      }
    }

    updateVisibility();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', slInitStickyBuyBar);
  } else {
    slInitStickyBuyBar();
  }

  } catch(e) { console.error(e); }
})();
})();
